import { useState } from 'react'

const useForm = (initialValues, onSubmit, validate) => {
	const [values, setValues] = useState(initialValues)
	const [errors, setErrors] = useState({})
	const [isSubmitting, setIsSubmitting] = useState(false)

	const handleSubmit = event => {
		if (event) event.preventDefault()

		const validated = validate ? validate(values) : values
		setErrors(validated)

		if (Object.keys(validated).length === 0) {
			setIsSubmitting(true)
			onSubmit()
		}
	}

	const handleChange = event => {
		event.persist()
		const { name, value } = event.target
		if (errors[name]) {
			setErrors(errors => {
				const { [name]: omitted, ...rest } = errors
				return rest
			})
		}
		setValues(values => ({ ...values, [name]: value }))
	}

	const handleReset = () => {
		setValues(initialValues)
	}

	return {
		values,
		setValues,
		errors,
		setErrors,
		isSubmitting,
		setIsSubmitting,
		handleSubmit,
		handleChange,
		handleReset,
	}
}

export default useForm
